function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, this.dataset.associatedIndices, 0, this.dataset.customStick);

    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    this.currentItemCount = Array.from(this.querySelectorAll('[data-current-value]'))
      .reduce((total, quantityEl) => total + parseInt(quantityEl.dataset.currentValue), 0);
    this.checkoutCTA = document.getElementById('checkout') || document.getElementById('CartDrawer-Checkout');
    this.fitInStore = document.getElementById('custom-stick-fit-in-store');

    //View Cart data layer event
    fetch('/cart.json')
    .then(response => {
      return (response.json());
    })
    .then((data) => {
      document.dispatchEvent(new CustomEvent('ViewCart', {
        detail: {
          country: window.Shopify.country,
          cartItems: data.items,
          cart: data
        }
      }));
    })
    .catch((error) => console.error('Error:', error));

    //initialize CustomStickFitInStoreIndicator value to no if fit in store is there
    if (this.fitInStore !== null) {
      this.updateFitInStoreAttribute('false', '');
    }
    
    //custom helmet changes
    var url = document.URL;
    var params = new URLSearchParams(new URL(url).search);
    var twikitData = params.get('twikit_data');
    if (twikitData !== null) {
      var helmetData = decodeURIComponent(url.split('?')[1]);
      var parameters = {}, hash;
      if (helmetData != undefined) {
        helmetData = helmetData.split('&');
        for(var i = 0; i < helmetData.length; i++) {
          hash = helmetData[i].split('=');
          if (hash[0] === 'twikit_data')
            parameters[hash[1]] = hash[2];
          else
            parameters[hash[0]] = hash[1];
        }
      }
      this.addHelmetToCart(parameters);
    }

    //DIG-134 custom product recalculate estimated delivery time
    if (window.custom_product) {
      //this.updateEstimatedDeliveryDate();
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (this.fitInStore !== null) {
      this.updateFitInStoreValue(event.target.dataset.fitInStore);
    }
    if (event.target.dataset.index !== undefined) {
      this.updateQuantity(event.target.dataset.index, event.target.dataset.associatedIndices, event.target.value, event.target.dataset.customStick, document.activeElement.getAttribute('name'), event.target, event.target.dataset.extraSteel);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: this.mainCartItems.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, associatedIndices, quantity, customStick, name, target, extraSteel) {
    const associatedIndexArray = associatedIndices?.split(',')?.filter(index => index != '') ?? [];

    // Check associated line item inventories before allowing update
    let maxQty = Infinity;

    //Define arrays for associated line item name, id and sku for GTM
    let associatedLineItemSkuArray = [];
    let associatedLineItemIDArray = [];
    let associatedLineItemNameArray = [];
    let associatedLineItemTypeArray = [];

    associatedIndexArray.forEach(associatedIndex => {
      const associatedMaxQty = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.max;
      associatedLineItemSkuArray[associatedIndex] = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.itemsku;
      associatedLineItemIDArray[associatedIndex] = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.itemid;
      associatedLineItemNameArray[associatedIndex] = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.itemname;
      associatedLineItemTypeArray[associatedIndex] = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.itemtype;
      if (associatedMaxQty && associatedMaxQty !== '0') {
        maxQty = Math.min(associatedMaxQty, maxQty);
      }
    })

    if (quantity > maxQty) {
      if (target) {
        target.value = maxQty;
        target.dataset.currentValue = maxQty.toString();
        alert(window.cartStrings.quantityError.replace('[quantity]', maxQty));
      }
    }

    let attemptedQuantity = Math.min(quantity, maxQty);

    this.enableLoading(line);
    associatedIndexArray.forEach(lineIndex => {
      this.enableLoading(lineIndex);
    })

    const body = JSON.stringify({
      line,
      quantity: attemptedQuantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    //Setting lineitem name, id and sku to variables for GTM
    let removedLineItemSku = document.getElementById(`CartItem-${line}`)?.dataset.itemsku;
    let removedLineItemID = document.getElementById(`CartItem-${line}`)?.dataset.itemid;
    let removedLineItemName = document.getElementById(`CartItem-${line}`)?.dataset.itemname;
    let removedLineItemType = document.getElementById(`CartItem-${line}`)?.dataset.itemtype;

    fetch(`${window.routes.cart_change_url}`, {...window.fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        let addedQuantity = parsedState?.items[line - 1]?.quantity ?? attemptedQuantity;

        if (attemptedQuantity > addedQuantity) {
          alert(window.cartStrings.quantityError.replace('[quantity]', addedQuantity));
          attemptedQuantity = addedQuantity;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        //datalayer event for product remove
        if (attemptedQuantity < 1) {
          document.dispatchEvent(new CustomEvent('RemoveFromCart', {
            detail: {
              productID: removedLineItemID,
              productSku: removedLineItemSku,
              productName: removedLineItemName,
              country: window.Shopify.country,
              associatedItem: false,
              productType: removedLineItemType
            }
          }));
        }
      })
      .then(() => {
        const associatedFetches = associatedIndexArray.map((associatedIndex) => {
          if (extraSteel > 0) {
            attemptedQuantity = extraSteel * attemptedQuantity;
          }
          const associatedBody = JSON.stringify({
            line: associatedIndex,
            quantity: attemptedQuantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          });

          return fetch(`${window.routes.cart_change_url}`, {...window.fetchConfig(), ...{ body: associatedBody }})
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartFooter = document.getElementById('main-cart-footer');

              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

              this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }));

              this.updateLiveRegions(parsedState.item_count);

              // Focus on the paired line item
              const lineItem =  document.getElementById(`CartItem-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

              //datalayer event for associated product remove
              if (attemptedQuantity < 1) {
                document.dispatchEvent(new CustomEvent('RemoveFromCart', {
                  detail: {
                    productID: associatedLineItemIDArray[associatedIndex],
                    productSku: associatedLineItemSkuArray[associatedIndex],
                    productName: associatedLineItemNameArray[associatedIndex],
                    country: window.Shopify.country,
                    associatedItem: true,
                    productType: associatedLineItemTypeArray[associatedIndex]
                  }
                }));
              }
            })
        })

        //change custom stick count and reload the cart if there is no custom stick in cart 
        if ((customStick === 'true') && (attemptedQuantity < 1)) {
          window.custom_stick_count = custom_stick_count - 1;
          if (window.custom_stick_count <= 0)
            location.reload();
        }

        // eslint-disable-next-line no-undef
        return Promise.all(associatedFetches);
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      }).finally(() => {
        this.disableLoading();
      });
  }

  updateFitInStoreValue(fitInStore) {
    var cartCheckout = document.getElementById('checkout');
    var storesElement = document.getElementById('fit-in-store-stores');
    var storeID;
    if (storesElement !== null) {
      var storeSelect = document.getElementById('stores');
      storeID = storeSelect.value;
    } else {
      storeID = '';
    }

    if (fitInStore !== undefined && fitInStore === 'yes') {
      cartCheckout.setAttribute('disabled', 'disabled');
      var storeObject = window.storeObject;
      if (storesElement === null) {
        var fitInStores = document.createElement('div');
        fitInStores.setAttribute('id', 'fit-in-store-stores');
        fitInStores.setAttribute('class', 'fit-in-store-stores field__input-wrapper field__input-wrapper--select');
        const selectStores = document.createElement('select');
        selectStores.setAttribute('class', 'field__input field__input--select');
        selectStores.setAttribute('id', 'stores');
        selectStores.setAttribute('name', 'storeValue');
        const optionStore = document.createElement('option');
        optionStore.value = 0;
        optionStore.text = 'Select Store';
        selectStores.add(optionStore);
        for (let count=0; count < window.storeObject.store.length; count++) {
          if ((window.storeObject.store[count].countryCode === window.fit_in_store_locale) && ('customAttributes' in window.storeObject.store[count])){
            const optionStore = document.createElement('option');
            for (let attributeCount=0; attributeCount < window.storeObject.store[count].customAttributes.customAttribute.length; attributeCount++){
              if (window.storeObject.store[count].customAttributes.customAttribute[attributeCount].attributeId === 'shipToID'){
                optionStore.value = window.storeObject.store[count].customAttributes.customAttribute[attributeCount].text;
                optionStore.text = window.storeObject.store[count].name + ' - ' + window.storeObject.store[count].address1 + ', ' + window.storeObject.store[count].city + ', ' + window.storeObject.store[count].stateCode;
                selectStores.add(optionStore);
              }
            }
          }
        }
        fitInStores.appendChild(selectStores);
        this.fitInStore.appendChild(fitInStores);
      }
    } else if (fitInStore !== undefined && fitInStore === 'no') {
      cartCheckout.removeAttribute('disabled');
      this.updateFitInStoreAttribute('false', '');
      if (storesElement !== null) {
        storesElement.remove();
      }
    } else if  (storeID !== '' && storeID <= 0){
      cartCheckout.setAttribute('disabled', 'disabled');
      storeSelect.style.color = '#D41D32';
      storeSelect.style.border = '.1rem solid #D41D32';
    } else if (storeID !== ''){
      storeSelect.style.color = '#000000';
      storeSelect.style.border = '.1rem solid #000000';
      cartCheckout.removeAttribute('disabled');
      this.updateFitInStoreAttribute('true', storeID);
    }
  }

  updateLiveRegions(itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(lineIndex) {
    this.checkoutCTA.setAttribute('disabled', 'disabled');
    this.mainCartItems.classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${lineIndex} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.checkoutCTA.removeAttribute('disabled');
    this.mainCartItems.classList.remove('cart__items--disabled');
  }

  getHelmetObject(helmetCountry) {
    var helmet_object;
    if (helmetCountry === 'Canada') {
      helmet_object = [
        {
          "SKU": "688698574050",
          "VariantID": "43386764034301"
        }
      ];
    } else {
      helmet_object = [
        {
          "SKU": "688698574050",
          "VariantID": "43533811712238"
        }
      ];
    }
    return helmet_object;
  }

  addHelmetToCart(helmetData) {
    console.log(helmetData);
    var productID, 
    helmets_object = this.getHelmetObject(helmetData['user_profile[country]']);
    
    for (var i = 0; i < helmets_object.length; ++i) {
      var helmets = helmets_object[i];
      if(helmets.SKU == helmetData['helmet[sku]']){
        productID = helmets.VariantID;
        break;
      }
    }

    var attributes = {
      "Color": "helmet[color]",
      "_CustomHelmetColor": "helmet[color]",
      "Strap Color": "helmet[ear_loop_chin_strap_color]",
      "_CustomHelmetStrapColor": "helmet[ear_loop_chin_strap_color]",
      "Liner Color": "helmet[liner_color]",
      "_CustomHelmetLinearColor": "helmet[liner_color]",
      "Size": "helmet[size]",
      "_CustomHelmetSize": "helmet[size]",
      "Type": "helmet[type]",
      "_CustomHelmetType": "helmet[type]",
      "_CustomHelmetStoreId": "scan[store_id]",
      "Nickname": "helmet[player_name]",
      "_CustomHelmetPlayerNickname": "helmet[player_name]",
      "Player Number": "helmet[player_number]",
      "_CustomHelmetPlayerNumber": "helmet[player_number]",
      "Text Color": "helmet[text_color]",
      "_CustomHelmetTextColor": "helmet[text_color]",
    };

    // logic for estimated delivery dates
    var delivery_LeadTime = window.custom_helmet_lead_time;
    var estimated_Date = new Date();
    estimated_Date.setDate(estimated_Date.getDate() + delivery_LeadTime);
    var dd = String(estimated_Date.getDate()).padStart(2, '0');
    var mm = String(estimated_Date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = estimated_Date.getFullYear();
    estimated_Date = mm + '/' + dd + '/' + yyyy;

    /*initiaing lineitem properties*/
    var lineItemProperties = {};
    for (var key in attributes) {
      var value = attributes[key];
      var specValue = helmetData[value];
      if (specValue) {
        lineItemProperties[key] = specValue;
      }
    }
    lineItemProperties["Estimated Delivery Date"] = estimated_Date;
    lineItemProperties["_CustomerRequestDate"] = estimated_Date;
    lineItemProperties["_RecipeString"] = helmetData['recipe_id'];

    var formData = {
      'items': [{
        'id': productID,
        'quantity': 1,
        'properties': lineItemProperties
      }]
    };

    /*add to cart shopify*/
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {return response.json();})
    .then(response => {
      window.location.replace("/cart");
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  updateFitInStoreAttribute(FitInStoreIndicator, FitInStoreID) {
    const body = JSON.stringify({
      attributes : {
        'CustomStickFitInStoreIndicator': FitInStoreIndicator,
        'CustomStickFitInStoreID': FitInStoreID
      }
    });
    fetch(`${window.routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }})
    .then(response => {return response.json();})
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  updateEstimatedDeliveryDate() {
    fetch('/cart.json')
    .then(response => {
      return (response.json());
    })
    .then((data) => {
      var cartItems = data.items;
      for (var count=0; count<cartItems.length; count++) {
        if ('_CustomStickFamily' in cartItems[count].properties && '_LeadTime' in cartItems[count].properties && cartItems[count].properties['_CustomStickFamily'] != '' && cartItems[count].properties['_CustomStickFamily'].includes('Goalie')) {
          this.calculateEstimatedDeliveryDate(cartItems[count].key, cartItems[count].properties, cartItems[count].quantity);
        } else if ('_CustomStickFamily' in cartItems[count].properties && '_LeadTime' in cartItems[count].properties && cartItems[count].properties['_CustomStickFamily'] != '' && cartItems[count].properties['_CustomStickFamily'].includes('Quick')) {
          this.calculateEstimatedDeliveryDate(cartItems[count].key, cartItems[count].properties, cartItems[count].quantity);
        } else if ('_CustomStickFamily' in cartItems[count].properties && '_LeadTime' in cartItems[count].properties && cartItems[count].properties['_CustomStickFamily'] != '') {
          this.calculateEstimatedDeliveryDate(cartItems[count].key, cartItems[count].properties, cartItems[count].quantity);
        } else if (!('_associatedWithLineItemKey' in cartItems[count].properties) && '_LeadTime' in cartItems[count].properties && '_CustomSkateFamily' in cartItems[count].properties && cartItems[count].properties['_CustomSkateFamily'] != '') {
          this.calculateEstimatedDeliveryDate(cartItems[count].key, cartItems[count].properties, cartItems[count].quantity);
        } else if (!('_associatedWithLineItemKey' in cartItems[count].properties) && '_LeadTime' in cartItems[count].properties && '_CustomSkateBladeType' in cartItems[count].properties && cartItems[count].properties['_CustomSkateBladeType'] != '') {
          this.calculateEstimatedDeliveryDate(cartItems[count].key, cartItems[count].properties, cartItems[count].quantity);
        }
      }
    })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
    }).finally(() => {
      this.disableLoading();
    });
  }

  async calculateEstimatedDeliveryDate(lineItemKey, lineItemProperties, lineItemQuantity) {
    var estimated_Date = new Date();
    estimated_Date.setDate(estimated_Date.getDate() + lineItemProperties['_LeadTime']);
    var dd = String(estimated_Date.getDate()).padStart(2, '0');
    var mm = String(estimated_Date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = estimated_Date.getFullYear();
    estimated_Date = mm + '/' + dd + '/' + yyyy;
    console.log('estimated_Date', estimated_Date);
    lineItemProperties['Estimated Delivery Date'] = estimated_Date;
    lineItemProperties['_CustomerRequestDate'] = estimated_Date;


    const body = JSON.stringify({
      id: lineItemKey,
      properties: lineItemProperties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      quantity: lineItemQuantity
    });

    await fetch(`${window.routes.cart_change_url}`, {...window.fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
    }).finally(() => {
      this.disableLoading();
    });
  }
}


customElements.define('cart-items', CartItems);



class ImageLoader {
    constructor(querySelector, pollInterval = 1000, maxRetries = 10) {
        this.querySelector = querySelector;
        this.pollInterval = pollInterval;
        this.maxRetries = maxRetries;
    }

    async init() {
        const cartImages = document.querySelectorAll(this.querySelector);
        for (let img of cartImages) {
            img.style.display = 'none'; // Hide image initially
            let loaded = await this.pollImageLoad(img);
            if (loaded) {
                img.style.display = ''; // Display the image if loaded successfully
            }
        }
    }

    async pollImageLoad(element) {
        let retries = 0;
        while (retries < this.maxRetries) {
            let loaded = await this.checkImage(element);
            if (loaded) {
                return true; // Return true if the image is loaded successfully
            } else {
                retries++;
                console.log(`Retrying to load image: ${element.src}, attempt ${retries}`);
                await new Promise(resolve => setTimeout(resolve, this.pollInterval));
                console.log('setting src', element);
                //let parentElement = element.parentElement;
                //let newElement = element.cloneNode();
                //element.remove();
                //parentElement.append(newElement);
              
                let baseSrc = element.src.indexOf('?') > -1 ? element.src.substring(0, element.src.indexOf('?')) : element.src;
                element.src = baseSrc + "?" + retries;
            }
        }
        return false; // Return false if the image failed to load after max retries
    }

    checkImage(element) {
        return new Promise((resolve) => {
            let img = new Image();
            img.onload = () => {
                img.onload = null;
                img.onerror = null;
                resolve(true);
            };
            img.onerror = () => {
                img.onload = null;
                img.onerror = null;
                resolve(false);
            };
            img.src = element.src
        });
    }
}

// Polling script integration
const imageLoader = new ImageLoader('.cart-item__image');
imageLoader.init();
